"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.useSquidStyles = exports.SquidStyleProvider = exports.SquidStyleContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var utils_1 = require("./utils");
exports.SquidStyleContext = (0, react_1.createContext)({
    styles: undefined,
});
var SquidStyleProvider = function (_a) {
    var styles = _a.styles, selector = _a.selector, useDangerousRender = _a.useDangerousRender, _b = _a.branding, branding = _b === void 0 ? 'base' : _b, children = _a.children;
    var squidStyles = (0, react_1.useMemo)(function () { return (0, utils_1.createSquidStyles)(styles, selector); }, [styles, selector]);
    return ((0, jsx_runtime_1.jsx)(exports.SquidStyleContext.Provider, __assign({ value: { styles: squidStyles, useDangerousRender: useDangerousRender, branding: branding } }, { children: children })));
};
exports.SquidStyleProvider = SquidStyleProvider;
var useSquidStyles = function () { return (0, react_1.useContext)(exports.SquidStyleContext); };
exports.useSquidStyles = useSquidStyles;
var Style = function () {
    var styles = (0, exports.useSquidStyles)().styles;
    return (0, jsx_runtime_1.jsx)("style", { dangerouslySetInnerHTML: { __html: styles !== null && styles !== void 0 ? styles : '' } });
};
exports.Style = Style;
